var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.325 11.298 7.89-8.009A.93.93 0 0 1 15.908 3q.407 0 .692.289l.895.908q.285.29.305.702a.9.9 0 0 1-.265.702L11.23 12l6.304 6.4q.285.288.265.7a1.04 1.04 0 0 1-.305.703l-.895.908a.93.93 0 0 1-.692.289.93.93 0 0 1-.691-.289l-7.89-8.01A.9.9 0 0 1 7 12q0-.413.325-.702"
  })));
};
export default SvgChevronLeft;